import {
  FETCH_COMPANIES_SUCCESS,
  FETCH_CUSTOMERS_SUCCESS,
  SAVE_COMPANIES,
  SAVE_CUSTOMER,
  DELETE_COMPANIES,
  SET_SELECTED_COMPANY_ID,
  SET_SELECTED_CUSTOMER_ID
} from "actions/types";

import { companiesRead, customersRead, companiesSave, customerSave, companiesDelete } from '../api'
import {
  dataFailure,
  dataSuccess,
} from "./general";

const fetchCompaniesSuccess = (Companies) => {
  return {
    type: FETCH_COMPANIES_SUCCESS,
    payload: Companies
  }
}

export const fetchCompanies = () => {
  return async (dispatch) => {
    try {
      const companiesJSONData = await dispatch(companiesRead())
      await dispatch(fetchCompaniesSuccess(companiesJSONData))
    } catch(err) {
      await dispatch(dataFailure(err.message))
    }
  }
}

const fetchCustomersSuccess = (Companies) => {
  return {
    type: FETCH_CUSTOMERS_SUCCESS,
    payload: Companies
  }
}

export const fetchCustomers = () => {
  return async (dispatch) => {
    try {
      const JSONData = await dispatch(customersRead())
      await dispatch(fetchCustomersSuccess(JSONData))
    } catch(err) {
      await dispatch(dataFailure(err.message))
    }
  }
}

const saveCompaniesData = (values) => {
  return {
    type: SAVE_COMPANIES,
    payload: values,
  };
};

export const saveCompanies = (values) => {
  return async (dispatch) => {
    try {
      const JSONData = await dispatch(companiesSave(values));
      await dispatch(saveCompaniesData(JSONData));
      await dispatch(dataSuccess());
    } catch (err) {
      await dispatch(dataFailure(err.message));
    }
  };
};

const saveCustomerData = (values) => {
  return {
    type: SAVE_CUSTOMER,
    payload: values,
  };
};

export const saveCustomer = (values) => {
  return async (dispatch) => {
    try {
      const JSONData = await dispatch(customerSave(values));
      await dispatch(saveCustomerData(JSONData));
      await dispatch(dataSuccess());
    } catch (err) {
      await dispatch(dataFailure(err.message));
    }
  };
};

const deleteCompanyData = (values) => {
  return {
    type: DELETE_COMPANIES,
    payload: values,
  };
};

export const deleteCompanies = (values) => {
  return async (dispatch) => {
    try {
      const JSONData = await dispatch(companiesDelete(values));
      await dispatch(deleteCompanyData(JSONData));
      await dispatch(dataSuccess());
    } catch (err) {
      await dispatch(dataFailure(err.message));
    }
  };
};

export const setSelectedCompanyId = (values) => {
  return {
    type: SET_SELECTED_COMPANY_ID,
    payload:values
  }
}

export const setSelectedCustomerId = (values) => {
  return {
    type: SET_SELECTED_CUSTOMER_ID,
    payload:values
  }
}